{
  "reactions": {
    "react": "Reagera",
    "like": "Gilla",
    "fire": "Eld",
    "clap": "Applåd",
    "trophy": "Trofé",
    "muscle": "Muskel",
    "failed_to_add": "Kunde inte lägga till reaktion",
    "who_reacted": "Reaktioner",
    "no_reactions": "Inga reaktioner än",
    "total": "{{count}} reaktioner",
    "all": "Alla"
  },
  "comments": {
    "title": "Kommentarer",
    "write_comment": "Skriv en kommentar...",
    "write_reply": "Skriv ett svar...",
    "post_comment": "Skicka kommentar",
    "reply": "Svara",
    "replies": "svar",
    "no_comments": "Inga kommentarer än. Var först att kommentera!",
    "comment_posted": "Kommentar skickad",
    "reply_posted": "Svar skickat",
    "failed_to_post": "Kunde inte skicka kommentar",
    "comment_deleted": "Kommentar raderad",
    "failed_to_delete": "Kunde inte radera kommentar",
    "confirm_delete": "Är du säker på att du vill radera denna kommentar?",
    "confirm_delete_header": "Ta bort kommentar"
  }
}
